module.exports = __webpack_public_path__ + "static/media/galeryAntihumidity8.f8c01210.jpg";